<template>
  <div
    class="w-367px h-[calc(100%-140px)] bg-contain bg-no-repeat absolute component-container transition-all top-120px"
    :class="zIndexClassName"
    :style="{
      left: baseProps.location === 'left' ? '100px' : '',
      right: baseProps.location === 'right' ? '20px' : '',
    }"
  >
    <div class="flex w-full mb-10px" v-if="baseProps.coexistenceNum > 1">
      <div
        @click="changeActive(item)"
        v-for="item in componentList"
        :key="item.code"
        class="relative cursor-default tag-item ml-2px mr-2px h-30px bg-contain bg-no-repeat flex items-center pl-10px pr-5px text-14px"
        :class="[item.code === activeComponent ? 'text-white tag_select' : 'text-[#00B6CF] tag']"
      >
        <span class="w-72px truncate">{{ item.name }}</span>
        <span class="iconfont icon-line-close cursor-pointer" @click.stop="removeTag(item)"></span>
      </div>
    </div>
    <div
      class="flex items-center justify-center absolute single-close w-24px h-24px z-999 cursor-pointer rounded-[50%]"
      v-else
      @click.stop="removeTag(componentList[0])"
    >
      <span class="text-12px iconfont icon-line-close text-[#34b9f2]"></span>
    </div>
    <div
      class="w-full"
      :class="{ 'mt-30px': baseProps.coexistenceNum <= 1 }"
      :style="{
        height: baseProps.coexistenceNum <= 1 ? 'calc(100% - 35px)' : 'calc(100% - 45px)',
      }"
    >
      <!-- <div class="com-title relative mb-10px w-full h-45px pl-10px">
        <div class="absolute text-20px top-15px left-10px text-white w-max-130px truncate">
          {{ activeName }}
        </div>
      </div> -->
      <CardTitle :title="actualActiveName" cardType="default"></CardTitle>
      <div class="h-[calc(100%-60px)]">
        <keep-alive :include="keepAliveComponents">
          <component
            v-if="activeComponent && componentList.length"
            :is="activeComponent"
            :player="player"
            :currentComponent="activeComponent"
            :transferProps="transferProps[activeComponent]"
            :customProps="customProps"
            :cloudRender="cloudRender"
            :labelList="labelList"
            :sourceId="sourceId"
            :showObjInfoDialog="showObjInfoDialog"
            :showDocumentDialog="showDocumentDialog"
            :modelNode="modelNode"
            :onlineTagList="onlineTagList"
            :openDialog="openDialog"
            :collisionMaterialObj="materialObj"
            :mode="mode"
            :CrossSectionShow="CrossSectionShow"
            :modelDetail="modelDetail"
            :currentNode="currentNode"
            :deviceInfo="deviceInfo"
            @transferEvent="transferEvent"
            @showVideoWall="$emit('showVideoWall')"
            @operateTrajectory="operateTrajectory"
            @loadingSwitch="loadingSwitch"
            @updateDeviceInfo="updateDeviceInfo"
            @changeModel="changeModel"
            @PersonnelInfo="handlePersonnelInfo"
          ></component>
        </keep-alive>
      </div>
    </div>

    <device-ledger-tab-list
      class="absolute"
      v-if="activeOrigin === 'DeviceLedger'"
      :transferProps="transferProps[activeComponent]"
    ></device-ledger-tab-list>
  </div>
</template>

<script>
import CardTitle from '../../../../components/cockpit/CardTitle'
import exportComponents from '../../assets/js/exports/exportsComponents'
import DeviceLedgerTabList from '../business/DeviceLedger/DeviceLedgerTabList'
import { UNALLOW_COEXIST_COM } from '../../assets/js/model/basicCode'

export default {
  components: {
    ...exportComponents,
    CardTitle,
    DeviceLedgerTabList,
  },
  name: 'ComponentContainer',
  props: {
    baseProps: {
      type: Object,
      defalut: () => {
        return {
          location: 'left',
          // 当前激活组件
          currentComponent: {},
          // 最大共存数
          coexistenceNum: 3,
        }
      },
    },
    materialObj: {
      type: Object,
      defalut: {},
    },
    modelDetail: {
      type: Object,
      defalut: () => {
        return {
          filePath: '',
          materialFileId: '',
          modelFileId: '', // 模型文件id，云渲染路径又是模型加载名称
        }
      },
    },
    deviceInfo: {
      // 装置信息
      type: Object,
      defalut: () => {
        return {
          deviceName: null,
          deviceId: null,
          modelId: null,
        }
      },
    },
    // 断面图标状态
    CrossSectionShow: {
      type: Boolean,
      defalut: false,
    },
    currentNode: {
      type: Number,
      defalut: null,
    },
    customProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    /** 场景id */
    sourceId: {
      type: String,
      defalut: '',
    },
    // 云渲染实例
    player: {
      type: Object,
      defalut: null,
    },
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    // 通知关闭的组件
    noticeCloseComponent: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    // 通知关闭的标签
    noticeCloseLabel: {
      type: Array,
      defalut: () => {
        return []
      },
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
    labelList: {
      type: Array,
      default: () => {
        return []
      },
    },
    onlineTagList: {
      type: Array,
      default: () => {
        return []
      },
    },
    // 显示对象信息的文件弹窗
    showObjInfoDialog: {
      type: Boolean,
      default: false,
    },
    // 显示移交文档的文件弹窗
    showDocumentDialog: {
      type: Boolean,
      default: false,
    },
    // 模型点选的节点node
    modelNode: {
      type: Object,
      default: () => {},
    },
    mode: {
      type: String,
      default: 'visualization',
    },
    // z-index类名
    zIndexClassName: {
      type: String,
      default: 'z-998',
    },
  },
  data() {
    return {
      componentList: [],
      activeComponent: '',
      activeName: '',
      activeOrigin: '',
      // 功能打开之后需要再打开的二级弹框
      openDialog: {},
    }
  },
  computed: {
    keepAliveComponents() {
      const clipComs = ['AllClip', 'PartClipBox', 'ThreePanel']
      return _.map(this.componentList, (item) => {
        if (clipComs.includes(item.code)) {
          return 'ClipTool'
        }
        return item.code
      }).join(',')
    },
    actualActiveName() {
      let actualActiveName
      switch (this.activeName) {
        case '智慧安防':
          actualActiveName = '安防设备统计'
          break
        case '作业安全':
          actualActiveName = '作业情况统计'
          break
        default:
          actualActiveName = this.activeName
          break
      }
      return actualActiveName
    },
  },
  created() {
    if (this.player) {
      window.player = this.player
    }
  },
  watch: {
    noticeCloseComponent: {
      handler(data) {
        if (data.code) {
          const filterComponent = _.filter(this.componentList, (item) => {
            return item.origin === data.code || item.code === data.code
          })
          _.forEach(filterComponent, (item) => {
            this.removeTag(item)
          })
        }
      },
      deep: true,
    },
    noticeCloseLabel: {
      handler(closeList) {
        const filterComponent = _.filter(this.componentList, (item) => {
          return (
            item.origin === 'tag' &&
            _.some(closeList, (label) => {
              return item.originTagName === label.code
            })
          )
        })
        _.forEach(filterComponent, (item) => {
          this.removeTag(item)
        })
      },
      deep: true,
    },
    'baseProps.currentComponent': {
      handler(data) {
        if (data.code) {
          const findComponentIndex = _.findIndex(this.componentList, (item) => {
            return item.code === data.code
          })
          if (
            findComponentIndex !== -1 &&
            data.origin !== this.componentList[findComponentIndex].origin
          ) {
            this.componentList.splice(findComponentIndex, 1, data)
          } else if (findComponentIndex === -1) {
            // 是否存在互斥组件，如果有则关闭
            const mutexIndex = _.findIndex(this.componentList, (item) => {
              return (
                UNALLOW_COEXIST_COM[data.code] && UNALLOW_COEXIST_COM[data.code].includes(item.code)
              )
            })
            if (mutexIndex !== -1) {
              this.$emit('closeComponent', this.componentList[mutexIndex], false)
              this.componentList.splice(mutexIndex, 1)
            }
            // 容器组件最多放三个组件
            if (this.componentList.length >= this.baseProps.coexistenceNum) {
              this.$emit('closeComponent', this.componentList[0], false)
              this.componentList.splice(0, 1)
            }
            // 只能放单个组件的情况
            if (this.baseProps.coexistenceNum <= 1 && !_.isEmpty(this.componentList)) {
              this.$emit('closeComponent', this.componentList[0], false)
              this.componentList = []
            }
            this.componentList.push(data)
          } else if (data.origin === this.componentList[findComponentIndex].origin) {
            this.componentList[findComponentIndex] = data
          }
          this.openDialog = data?.openDialog || {}
          this.changeActive(data)
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 处理人员详情
    handlePersonnelInfo() {
      this.$emit('PersonnelInfo')
    },
    // 组件内部传递出来的事件
    transferEvent(data) {
      if (data.type === 'close') {
        this.$emit('closeComponent', data.toCom, _.isEmpty(this.componentList))
      }
      this.$emit('transferEvent', data)
    },
    // 打开关闭加载动画
    loadingSwitch({ bol, title }) {
      this.$emit('loadingSwitch', { bol, title })
    },
    // 更新装置信息
    updateDeviceInfo(detail) {
      this.$emit('updateDeviceInfo', detail)
    },
    changeModel(changeModelDetail) {
      this.$emit('changeModel', changeModelDetail)
    },
    // 切换组件显示
    changeActive(tag) {
      // 点击移交文档，关闭对象信息窗口
      if (tag.code === 'HandoverDocuments') {
        this.$emit(
          'closeComponent',
          { code: 'ObjectInfo', origin: 'HandoverDocuments', name: '对象信息' },
          _.isEmpty(this.componentList)
        )
      }
      // 点击移交对象，打开对象信息窗口
      if (tag.code === 'HandoverObject') {
        this.$emit('transferEvent', {
          toCom: {
            code: 'ObjectInfo',
            name: '对象信息',
            origin: 'HandoverObject',
          },
          type: 'mainComponent',
        })
      }
      this.activeComponent = tag.code
      this.activeName = tag.name
      this.activeOrigin = tag.origin
      this.$emit('selectTab', tag.code)
    },
    // 关闭组件显示
    removeTag(tag) {
      if (tag) {
        const tagIndex = _.findIndex(this.componentList, ['code', tag.code])
        this.componentList.splice(tagIndex, 1)
        if (this.activeComponent === tag.code) {
          this.changeActive(_.isEmpty(this.componentList) ? {} : _.last(this.componentList))
        }
        this.$emit('closeComponent', tag, _.isEmpty(this.componentList))
      }
    },
    // 额外关闭组件显示
    handleExtraRemoveTag(tag) {
      if (tag) {
        const tagIndex = _.findIndex(this.componentList, ['code', tag.code])
        if ((tagIndex === 0 || tagIndex) && tagIndex !== -1) {
          this.componentList.splice(tagIndex, 1)
          if (this.activeComponent === tag.code) {
            this.changeActive(_.isEmpty(this.componentList) ? {} : _.last(this.componentList))
          }
          this.$emit('closeComponent', tag, _.isEmpty(this.componentList))
        }
      }
    },
    // 操作历史轨迹弹框的显示
    operateTrajectory(params) {
      this.$emit('operateTrajectory', params)
    },
  },
}
</script>

<style lang="scss" scoped>
.component-container {
  background-image: var(--containerBgImg);
  background-size: 100% 100%;
  padding: var(--containerPadding);
}
.tag {
  background-image: url('../../assets/images/tag.png');
}
.tag_select {
  background-image: url('../../assets/images/tag_select.png');
}
.tag-item {
  .icon-line-close {
    transform: scale(0.5);
  }
}
.single-close {
  background: linear-gradient(146.24deg, #114e67 0%, #0a364d 100%),
    radial-gradient(circle at 50% 50%, #59c8fc 0%, #52ace500 100%);
  border: 1px solid #34b9f2;
  top: var(--containerSingleCloseTop);
  right: var(--containerSingleCloseRight);
}
</style>
